import { Button, createTheme, ThemeProvider, Tooltip } from "@material-ui/core";
import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import AppColor from "../../utilities/AppColor";
import { Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";

const theme = createTheme({
  overrides: {
    MuiButton: {
      contained: {
        '&.Mui': {
          disabled: {
            opacity: 0.6,
            pointerEvents: 'none'
          }
        }
      }
    },
  },
});

const AppButton = (props) => {
  const {
    label,
    fullWidth,
    buttonColor,
    style,
    disableElevation,
    buttonProps,
    onClick,
    disabled,
    type,
    isLoading,
    children,
    mode,
    startIcon,
    endIcon,
    className,
    titleTooltip
  } = props;
  const { t } = useTranslation();

  const useStyles = makeStyles(() => ({
    button: {
      backgroundColor: AppColor.mainColor,
      color: AppColor.white,
      textTransform: "capitalize",
      borderRadius: 5,
      fontSize: 13,
      fontWeight: "600",
      minHeight: 38,
      boxShadow: 'none',
      '&:hover': {
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'
      }
    },
    buttonOutline: {
      backgroundColor: 'transparent',
      color: AppColor.mainColor,
      border: `2px solid ${AppColor.mainColor}`
    },
    disabled: {
      opacity: 0.5,
      pointerEvents: 'none',
      color: `${mode === 'outlined' ? buttonColor : AppColor.white}!important`,
      backgroundColor: `${mode === 'outlined' ? AppColor.greyLighten4 : buttonColor}!important`
    }
  }));

  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Tooltip title={titleTooltip ? titleTooltip : ''}>
      <Button
        variant="contained"
        fullWidth={fullWidth}
        className={classNames({
          [classes.button]: true,
          [classes.buttonOutline]: mode === 'outlined',
          [className]: true
        })}
        style={{
          ...buttonColor && mode === 'contained' && {
            backgroundColor: buttonColor
          },
          ...buttonColor && mode === 'outlined' && {
            backgroundColor: 'transparent',
            borderColor: buttonColor,
            color: buttonColor
          },
          ...style
        }}
        disableElevation={disableElevation}
        onClick={onClick}
        disabled={disabled}
        classes={{
          disabled: classes.disabled
        }}
        type={type}
        startIcon={startIcon}
        endIcon={endIcon}
        {...buttonProps}
      >
        {isLoading
          ? <Spinner color="primary" style={{
            width: '1rem',
            height: '1rem'
          }} />
          : children
            ? (<React.Fragment>
              {children}
              {
                label &&
                <span className="ml-2">
                  {t(label)}
                </span>
              }
            </React.Fragment>)
            : t(label)}
      </Button>
      </Tooltip>
    </ThemeProvider>
  );
};

AppButton.propTypes = {
  label: PropTypes.any,
  fullWidth: PropTypes.bool,
  buttonColor: PropTypes.string,
  disableElevation: PropTypes.bool,
  style: PropTypes.object,
  buttonProps: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(["button", "reset", "submit"]),
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  mode: PropTypes.oneOf(['contained', 'outlined']),
  startIcon: PropTypes.any,
  className: PropTypes.any,
  endIcon: PropTypes.any,
  titleTooltip: PropTypes.string
};

AppButton.defaultProps = {
  buttonColor: AppColor.mainColor,
  mode: 'contained'
};

export default AppButton;
